// Centralized exam pricing catalogue. Five exams, three tiers each (D:136-137).
// Prices are the sale prices; item lists mirror features/marketing/content/pricing.json
// and make no claim about content or tools the exam tier does not hold (D:66-67).
// Interview packages are chosen on the pricing page and are not catalogue plans.
export const EXAM_PACKAGES = [
  {
    id: 'lnat',
    category: 'law',
    title: 'LNAT',
    plans: [
      {
        tierKey: 'lnat_beginnings',
        name: 'LNAT Beginnings',
        price: '£0',
        period: 'free',
        description: 'Free practice',
        features: [
          'Official past papers',
          'Easy mock tests',
          'Law cases & tutorials'
        ],
        cta: 'Get Started',
        isFree: true
      },
      {
        tierKey: 'lnat_foundations',
        name: 'LNAT Foundations',
        price: '£60',
        period: 'one-off payment',
        description: 'Everything for the exam',
        features: [
          'All content in Beginnings',
          'Standard mock tests',
          'Essay questions'
        ],
        cta: 'Get Started'
      },
      {
        tierKey: 'lnat_beyond',
        name: 'LNAT Beyond',
        price: '£80',
        period: 'one-off payment',
        description: 'Foundations plus harder practice',
        features: [
          'All content in Foundations',
          'Hard mock tests'
        ],
        cta: 'Get Started'
      }
    ]
  },
  {
    id: 'tmua',
    category: 'maths',
    title: 'TMUA',
    plans: [
      {
        tierKey: 'tmua_beginnings',
        name: 'TMUA Beginnings',
        price: '£0',
        period: 'free',
        description: 'Free practice',
        features: [
          'Official past papers (both papers)',
          'Easy mock tests',
          'Topic practice',
          'Cases & tutorials'
        ],
        cta: 'Get Started',
        isFree: true
      },
      {
        tierKey: 'tmua_foundations',
        name: 'TMUA Foundations',
        price: '£60',
        period: 'one-off payment',
        description: 'Everything for the exam',
        features: [
          'All content in Beginnings',
          'Standard mock tests',
          'Proof & justification questions'
        ],
        cta: 'Get Started'
      },
      {
        tierKey: 'tmua_beyond',
        name: 'TMUA Beyond',
        price: '£80',
        period: 'one-off payment',
        description: 'Foundations plus harder practice',
        features: [
          'All content in Foundations',
          'Hard mock tests',
          'Logic & proof questions'
        ],
        cta: 'Get Started'
      }
    ]
  },
  {
    id: 'tara',
    category: 'reasoning',
    title: 'TARA',
    plans: [
      {
        tierKey: 'tara_beginnings',
        name: 'TARA Beginnings',
        price: '£0',
        period: 'free',
        description: 'Free practice',
        features: [
          'Official past papers',
          'Easy mock tests',
          'Topic practice',
          'Cases & tutorials'
        ],
        cta: 'Get Started',
        isFree: true
      },
      {
        tierKey: 'tara_foundations',
        name: 'TARA Foundations',
        price: '£60',
        period: 'one-off payment',
        description: 'Everything for the exam',
        features: [
          'All content in Beginnings',
          'Standard mock tests',
          'Writing Task essay grading & feedback'
        ],
        cta: 'Get Started'
      },
      {
        tierKey: 'tara_beyond',
        name: 'TARA Beyond',
        price: '£80',
        period: 'one-off payment',
        description: 'Foundations plus harder practice',
        features: [
          'All content in Foundations',
          'Hard mock tests',
          'Critical reasoning & problem solving question bank'
        ],
        cta: 'Get Started'
      }
    ]
  },
  {
    id: 'ucat',
    category: 'medicine',
    title: 'UCAT',
    plans: [
      {
        tierKey: 'ucat_beginnings',
        name: 'UCAT Beginnings',
        price: '£0',
        period: 'free',
        description: 'Free practice',
        features: [
          'Official practice tests',
          'Topic practice across all subtests',
          'Cases & tutorials'
        ],
        cta: 'Get Started',
        isFree: true
      },
      {
        tierKey: 'ucat_foundations',
        name: 'UCAT Foundations',
        price: '£60',
        period: 'one-off payment',
        description: 'Everything for the exam',
        features: [
          'All content in Beginnings',
          'Standard mock tests',
          'Question bank across all four subtests'
        ],
        cta: 'Get Started'
      },
      {
        tierKey: 'ucat_beyond',
        name: 'UCAT Beyond',
        price: '£80',
        period: 'one-off payment',
        description: 'Foundations plus harder practice',
        features: [
          'All content in Foundations',
          'Hard mock tests',
          'GMC ethics & NHS Constitution case scenarios'
        ],
        cta: 'Get Started'
      }
    ]
  },
  {
    id: 'esat',
    category: 'engineering',
    title: 'ESAT',
    plans: [
      {
        tierKey: 'esat_beginnings',
        name: 'ESAT Beginnings',
        price: '£0',
        period: 'free',
        description: 'Free practice',
        features: [
          'Official past papers',
          'Cases & tutorials'
        ],
        cta: 'Get Started',
        isFree: true
      },
      {
        tierKey: 'esat_foundations',
        name: 'ESAT Foundations',
        price: '£60',
        period: 'one-off payment',
        description: 'Everything for the exam',
        features: [
          'All content in Beginnings',
          'Standard mock tests',
          'Applied problem-solving questions'
        ],
        cta: 'Get Started'
      },
      {
        tierKey: 'esat_beyond',
        name: 'ESAT Beyond',
        price: '£80',
        period: 'one-off payment',
        description: 'Foundations plus harder practice',
        features: [
          'All content in Foundations',
          'Hard mock tests',
          'Deep-structure practice questions'
        ],
        cta: 'Get Started'
      }
    ]
  }
];
